import Layout from '@/components/layout/index.vue'

export default {
  path: 'authority',
  name: 'Authority',
  meta: {},
  component: Layout,
  redirect: { name: 'Authority.Office' },
  children: [
    {
      path: 'office',
      name: 'Authority.Office',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/office/index.ts')
    },
    {
      path: 'office/add',
      name: 'Authority.Office.Add',
      meta: { title: 'common.add', dep: 'Authority.Office' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/office/add.ts')
    },
    {
      path: 'office/modify/:id',
      name: 'Authority.Office.Modify',
      meta: { title: 'common.modify', dep: 'Authority.Office' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/office/modify.ts')
    },
    {
      path: 'sysmenu',
      name: 'Authority.Sysmenu',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysmenu/index.vue')
    },
    {
      path: 'sysmenu/add',
      name: 'Authority.Sysmenu.Add',
      meta: { title: 'common.add', dep: 'Authority.Sysmenu' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysmenu/add.vue')
    },
    {
      path: 'factory',
      name: 'Authority.Factory',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/factory/index.ts')
    },
    {
      path: 'factory/add',
      name: 'Authority.Factory.Add',
      meta: { title: 'common.add', dep: 'Authority.Factory' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/factory/add.ts')
    },
    {
      path: 'factory/modify/:id',
      name: 'Authority.Factory.Modify',
      meta: { title: 'common.modify', dep: 'Authority.Factory' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/factory/modify.ts')
    },
    {
      path: 'purchase-unit',
      name: 'Authority.PurchaseUnit',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/purchase-unit/index.ts')
    },
    {
      path: 'purchase-unit/add',
      name: 'Authority.PurchaseUnit.Add',
      meta: { title: 'common.add', dep: 'Authority.PurchaseUnit' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/purchase-unit/add.ts')
    },
    {
      path: 'purchase-unit/modify/:id',
      name: 'Authority.PurchaseUnit.Modify',
      meta: { title: 'common.modify', dep: 'Authority.PurchaseUnit' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/purchase-unit/modify.ts')
    },
    {
      path: 'db-setting',
      name: 'Authority.DBSetting',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/db-setting/index.ts')
    },
    {
      path: 'db-setting/add',
      name: 'Authority.DBSetting.Add',
      meta: { title: 'common.add', dep: 'Authority.DBSetting' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/db-setting/add.ts')
    },
    {
      path: 'db-setting/modify/:id',
      name: 'Authority.DBSetting.Modify',
      meta: { title: 'common.modify', dep: 'Authority.DBSetting' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/db-setting/modify.ts')
    },
    {
      path: 'sysrole',
      name: 'Authority.Sysrole',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysrole/index.ts')
    },
    {
      path: 'sysrole/add',
      name: 'Authority.Sysrole.Add',
      meta: { title: 'common.add', dep: 'Authority.Sysrole' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysrole/add.ts')
    },
    {
      path: 'sysrole/modify/:id',
      name: 'Authority.Sysrole.Modify',
      meta: { title: 'common.modify', dep: 'Authority.Sysrole' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysrole/modify.ts')
    },
    {
      path: 'sysuser',
      name: 'Authority.Sysuser',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysuser/index.ts')
    },
    {
      path: 'sysuser/add',
      name: 'Authority.Sysuser.Add',
      meta: { title: 'common.add', dep: 'Authority.Sysuser' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysuser/add.ts')
    },
    {
      path: 'sysuser/modify/:id',
      name: 'Authority.Sysuser.Modify',
      meta: { title: 'common.modify', dep: 'Authority.Sysuser' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/sysuser/modify.ts')
    },
    {
      path: 'data',
      name: 'Authority.Data',
      meta: {},
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/data/index.ts')
    },
    {
      path: 'data/add',
      name: 'Authority.Data.Add',
      meta: { title: 'common.add', dep: 'Authority.Data' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/data/add.ts')
    },
    {
      path: 'data/modify/:id',
      name: 'Authority.Data.Modify',
      meta: { title: 'common.modify', dep: 'Authority.Data' },
      component: () => import(/* webpackChunkName: "authority" */ '@/views/setting/authority/data/modify.ts')
    }
  ]
}
